module.exports = __webpack_public_path__ + "static/media/Ø3(4).6947a536.png";